var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { SdsModalBase } from '../modal/_sds-modal-base.lit';
import styles from './sds-drawer.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
const AVAILABLE_SIZES = ['lg', 'md', 'sm'];
/**
 *  Control represents drawer which renders nested content.
 *
 *  @slot text - The content to be rendered in this drawer.
 */
let SdsDrawer = (() => {
    var _SdsDrawer_icon_accessor_storage, _SdsDrawer_title_accessor_storage, _SdsDrawer__content_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-drawer')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsModalBase;
    let _instanceExtraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _title_decorators;
    let _title_initializers = [];
    let _title_extraInitializers = [];
    let __content_decorators;
    let __content_initializers = [];
    let __content_extraInitializers = [];
    let _set_size_decorators;
    var SdsDrawer = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsDrawer_icon_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _icon_initializers, '')));
            _SdsDrawer_title_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _title_initializers, '')));
            this._size = (__runInitializers(this, _title_extraInitializers), 'lg');
            _SdsDrawer__content_accessor_storage.set(this, __runInitializers(this, __content_initializers, []));
            this.containerTransitionEndHandler = (__runInitializers(this, __content_extraInitializers), () => {
                this.modalContainer.removeEventListener('transitionend', this.containerTransitionEndHandler);
                super.closeModal();
                this.modalContainer.removeAttribute('style');
            });
        }
        /**
         * The icon of this drawer.
         * @attr
         */
        get icon() { return __classPrivateFieldGet(this, _SdsDrawer_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsDrawer_icon_accessor_storage, value, "f"); }
        /**
         * The title of this drawer.
         * @attr
         */
        get title() { return __classPrivateFieldGet(this, _SdsDrawer_title_accessor_storage, "f"); }
        set title(value) { __classPrivateFieldSet(this, _SdsDrawer_title_accessor_storage, value, "f"); }
        get _content() { return __classPrivateFieldGet(this, _SdsDrawer__content_accessor_storage, "f"); }
        set _content(value) { __classPrivateFieldSet(this, _SdsDrawer__content_accessor_storage, value, "f"); }
        getComponentStyleId() {
            return 'sds-drawer';
        }
        get size() {
            return this._size;
        }
        /**
         * Specifies the size of the drawer component.
         * This attribute accepts predefined sizes defined in the `AVAILABLE_SIZES` array.
         * If an invalid size is provided, an error message is logged to the console.
         *
         * Setting this attribute updates the internal state of the component, which may affect
         * the layout and appearance of the drawer. The component re-renders to reflect the new size.
         *
         * @attr {string} size - The size of the drawer. Valid values are limited to those defined in `AVAILABLE_SIZES`.
         */
        set size(value) {
            const oldValue = this._size;
            this._size = value;
            this.requestUpdate('size', oldValue);
        }
        getStyles() {
            return SdsDrawer.styles;
        }
        getContent() {
            return this._content;
        }
        getSize() {
            return this._size;
        }
        render() {
            return html `
            <slot
                name="content"
                style="display: none"
                @slotchange="${() => this.onModalChange()}"
            ></slot>
        `;
        }
        renderIcon() {
            if (this.icon) {
                return html `
                <sds-icon class="sds-drawer__icon" size="24" name="${this.icon}"></sds-icon>
            `;
            }
        }
        prepareModal() {
            super.prepareModal();
            this.isReady = true;
        }
        closeModal() {
            if (this.isReady && !isNil(this.modalContentContainer)) {
                this.removeContainerTransform();
            }
        }
        openModal() {
            this.setTransformTimeout();
            super.openModal();
        }
        getSizeClass() {
            switch (this.getSize()) {
                case 'lg':
                    return 'sds-drawer--lg';
                case 'md':
                    return 'sds-drawer--md';
                case 'sm':
                    return 'sds-drawer--sm';
            }
        }
        getContainerClass() {
            return 'sds-drawer';
        }
        getContainerBodyClass() {
            return 'sds-drawer__body';
        }
        getGlobalStyles() {
            return '';
        }
        removeContainerTransform() {
            if (this.modalContainer.style.transform) {
                this.modalContainer.addEventListener('transitionend', this.containerTransitionEndHandler);
                this.modalContainer.style.transform =
                    document.documentElement.getAttribute('dir') === 'rtl'
                        ? 'translateX(-100%)'
                        : 'translateX(100%)';
            }
        }
        setTransformTimeout() {
            setTimeout(() => {
                this.modalContainer.style.transform = 'translateX(0)';
            }, 100);
        }
    };
    _SdsDrawer_icon_accessor_storage = new WeakMap();
    _SdsDrawer_title_accessor_storage = new WeakMap();
    _SdsDrawer__content_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsDrawer");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _icon_decorators = [property({ type: String })];
        _title_decorators = [property({ type: String })];
        __content_decorators = [queryAssignedElements({ slot: 'content' })];
        _set_size_decorators = [property({
                type: String,
                hasChanged: (newVal) => {
                    if (!AVAILABLE_SIZES.includes(newVal)) {
                        console.error(`Unexpected Size ${newVal}`);
                        return false;
                    }
                    else {
                        return true;
                    }
                },
            })];
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _title_decorators, { kind: "accessor", name: "title", static: false, private: false, access: { has: obj => "title" in obj, get: obj => obj.title, set: (obj, value) => { obj.title = value; } }, metadata: _metadata }, _title_initializers, _title_extraInitializers);
        __esDecorate(_classThis, null, __content_decorators, { kind: "accessor", name: "_content", static: false, private: false, access: { has: obj => "_content" in obj, get: obj => obj._content, set: (obj, value) => { obj._content = value; } }, metadata: _metadata }, __content_initializers, __content_extraInitializers);
        __esDecorate(_classThis, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsDrawer = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsDrawer = _classThis;
})();
export { SdsDrawer };
